<template>
  <b-form-group
    description="Choose from existing tags or type to create new tags"
  >
    <b-form-tags
      :value="value"
      @input="
        $emit('input', $event);
        resetSearch();
      "
    >
      <template
        v-slot="{
          tags,
          inputAttrs,
          inputHandlers,
          tagVariant,
          addTag,
          removeTag,
          disableAddButton,
          duplicateTagText,
          isDuplicate,
          duplicateTags
        }"
      >
        <ul
          class="b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center"
          key="tags_list"
        >
          <b-form-tag
            v-for="tag in tags"
            @remove="removeTag(tag)"
            :title="tag"
            :tag="'li'"
            :variant="tagVariant"
            class="mr-1 mt-1"
            :key="`tags_${tag}`"
            >{{ tag }}</b-form-tag
          >
          <li class="mt-1 flex-grow-1">
            <div class="d-flex">
              <input
                ref="input"
                v-bind="inputAttrs"
                @input="
                  onInputInput($event);
                  inputHandlers.input($event);
                "
                @change="inputHandlers.change($event)"
                @keydown="inputHandlers.keydown($event)"
                placeholder="Add tag..."
                class="b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0"
                :style="{ outline: 0, minWidth: '5rem' }"
                @focus="show = true"
                @blur="show = false"
              />
              <b-button
                class="b-form-tags-button py-0"
                :class="{ invisible: disableAddButton }"
                :style="{ fontSize: '90%' }"
                variant="outline-secondary"
                @click="addTag"
              >
                Add
              </b-button>
            </div>
            <b-dropdown
              size="sm"
              variant="outline-secondary"
              block
              toggle-class="d-none"
              :menu-class="[show && availableOptions.length > 0 ? 'show' : '']"
            >
              <div
                class="dropdown-wrapper"
                :style="{ 'max-height': `${maxHeight}px`, overflow: 'scroll' }"
              >
                <b-dropdown-item-button
                  v-for="option in availableOptions"
                  :key="option.name"
                  @mousedown.native="
                    onOptionClick({ option: option.name, addTag })
                  "
                  button-class="d-flex justify-content-between align-items-center"
                >
                  {{ option.name }}
                  <b-badge variant="primary" pill>{{ option.count }}</b-badge>
                </b-dropdown-item-button>
              </div>
            </b-dropdown>
          </li>
        </ul>
        <div key="tags_feedback" v-if="isDuplicate">
          <b-form-text>
            {{ duplicateTagText }}: {{ duplicateTags.join(" ") }}
          </b-form-text>
        </div>
      </template>
    </b-form-tags>
  </b-form-group>
</template>

<script>
import { BFormTags } from "bootstrap-vue";

export default {
  name: "TagAdder",
  components: { BFormTags },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    maxHeight: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      show: false,
      search: ""
    };
  },
  computed: {
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      // Filter out already selected options
      const options = this.options.filter(
        opt => this.value.indexOf(opt.name) === -1
      );
      if (criteria) {
        // Show only options that match criteria
        return options.filter(
          opt => opt.name.toLowerCase().indexOf(criteria) > -1
        );
      }
      // Show all options available
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return "There are no tags matching your search criteria";
      }
      return "";
    }
  },
  methods: {
    onOptionClick({ option, addTag }) {
      addTag(option);
      this.search = "";
    },
    onInputInput(evt) {
      this.search = evt.target.value;
    },
    resetSearch() {
      this.search = "";
    }
  }
};
</script>
